import angular from 'angular';
import helloPackViewer from './helloPackViewer';
import './style.scss';

export default angular
  .module('helloPack.scenes.helloPackViewer', [])
  .component('helloPackViewer', helloPackViewer).name;
